import { simpleLookupManagementConfig } from "../../../../records/lookup/utils/simpleLookupManagementConfig";

import { vsLookupManagementServiceProviderName } from "./lookupManagement";

export const vsObjectName = "gamingContractCostType";

const url = "api/contract/gamingContract/costType";

export const CostTypeConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Cost Type",
  objectName: vsObjectName,
  url,
});
